<div class="template-parameter-container">
    <!-- Header Section -->
    <div class="parameter-header">
        <div class="header-content">
            <h2 class="parameter-title">
                <mat-icon>settings</mat-icon>
                Managementul Parametrilor Template
            </h2>
            <p class="parameter-subtitle">
                Gestionează parametrii globali pentru toate template-urile inteligente
            </p>
        </div>
        <div class="header-actions">
            <button mat-stroked-button (click)="refreshParameters()">
                <mat-icon>refresh</mat-icon>
                Actualizează
            </button>
            <button mat-raised-button color="primary" (click)="addParameter()" [disabled]="isSaving">
                <mat-icon>add</mat-icon>
                Adaugă parametru
            </button>
        </div>
    </div>

    <!-- Filters Section -->
    <div class="filters-section">
        <mat-card>
            <mat-card-content>
                <div class="filters-row">
                    <mat-form-field appearance="outline">
                        <mat-label>Căutare parametru</mat-label>
                        <input matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
                            placeholder="Nume sau descriere...">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Tip parametru</mat-label>
                        <mat-select [(ngModel)]="selectedType" (selectionChange)="applyFilters()">
                            <mat-option value="">Toate tipurile</mat-option>
                            <mat-option value="text">Text</mat-option>
                            <mat-option value="number">Număr</mat-option>
                            <mat-option value="date">Dată</mat-option>
                            <mat-option value="boolean">Da/Nu</mat-option>
                            <mat-option value="select">Listă opțiuni</mat-option>
                            <mat-option value="textarea">Text lung</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Categorie</mat-label>
                        <mat-select [(ngModel)]="selectedCategory" (selectionChange)="applyFilters()">
                            <mat-option value="">Toate categoriile</mat-option>
                            <mat-option value="system">Sistem</mat-option>
                            <mat-option value="user">Utilizator</mat-option>
                            <mat-option value="document">Document</mat-option>
                            <mat-option value="organization">Organizație</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="filter-checkboxes">
                        <mat-checkbox [(ngModel)]="showOnlyRequired" (change)="applyFilters()" color="primary">
                            Doar obligatorii
                        </mat-checkbox>
                        <mat-checkbox [(ngModel)]="showOnlyActive" (change)="applyFilters()" color="primary">
                            Doar activi
                        </mat-checkbox>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Main Content -->
    <div class="parameter-content">
        <!-- Parameters List -->
        <div class="parameters-section">
            <mat-card class="parameters-card">
                <mat-card-header class="d-flex align-items-center gap-2">
                    <mat-card-title>
                        <mat-icon>list</mat-icon>
                        Parametrii Template ({{ filteredParameters.length }})
                    </mat-card-title>
                    <div class="card-actions">
                        <button mat-icon-button [matMenuTriggerFor]="bulkMenu"
                            [disabled]="selectedParameters.length === 0">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #bulkMenu="matMenu">
                            <button mat-menu-item (click)="bulkActivateParameters()">
                                <mat-icon>check_circle</mat-icon>
                                <span>Activează selectate</span>
                            </button>
                            <button mat-menu-item (click)="bulkDeactivateParameters()">
                                <mat-icon>cancel</mat-icon>
                                <span>Dezactivează selectate</span>
                            </button>
                            <button mat-menu-item (click)="bulkDeleteParameters()">
                                <mat-icon>delete</mat-icon>
                                <span>Șterge selectate</span>
                            </button>
                        </mat-menu>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <!-- Parameters Table -->
                    <div class="parameters-table" *ngIf="filteredParameters.length > 0">
                        <div class="table-header">
                            <mat-checkbox [checked]="allParametersSelected()" [indeterminate]="someParametersSelected()"
                                (change)="toggleAllParameters($event)" color="primary">
                            </mat-checkbox>
                            <span class="column-header name-column">Nume</span>
                            <span class="column-header type-column">Tip</span>
                            <span class="column-header category-column">Categorie</span>
                            <span class="column-header status-column">Status</span>
                            <span class="column-header usage-column">Utilizări</span>
                            <span class="column-header actions-column">Acțiuni</span>
                        </div>

                        <div class="parameter-row" *ngFor="let parameter of filteredParameters; trackBy: trackParameter"
                            [class.selected]="isParameterSelected(parameter.id)"
                            [class.modified]="parameter._isModified">

                            <div class="parameter-main">
                                <mat-checkbox [checked]="isParameterSelected(parameter.id)"
                                    (change)="toggleParameterSelection($event, parameter.id)" color="primary">
                                </mat-checkbox>

                                <div class="parameter-info">
                                    <div class="parameter-name">
                                        <span class="name">{{ parameter.name }}</span>
                                        <span class="key">{{ parameter.parameter_key }}</span>
                                    </div>
                                    <div class="parameter-description" *ngIf="parameter.description">
                                        {{ parameter.description }}
                                    </div>
                                    <div class="parameter-metadata">
                                        <span class="type-badge type-{{ parameter.type }}">{{
                                            getTypeLabel(parameter.type) }}</span>
                                        <span class="category-badge category-{{ parameter.category }}">{{
                                            getCategoryLabel(parameter.category) }}</span>
                                        <span class="required-badge" *ngIf="parameter.is_required">Obligatoriu</span>
                                    </div>
                                </div>

                                <div class="parameter-status">
                                    <mat-icon class="status-icon" [class.active]="parameter.is_active"
                                        [class.inactive]="!parameter.is_active">
                                        {{ parameter.is_active ? 'check_circle' : 'cancel' }}
                                    </mat-icon>
                                </div>

                                <div class="parameter-usage">
                                    <span class="usage-count">{{ parameter.usage_count || 0 }}</span>
                                    <span class="usage-label">template-uri</span>
                                </div>

                                <div class="parameter-actions">
                                    <button mat-icon-button (click)="editParameter(parameter)" matTooltip="Editează">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button mat-icon-button (click)="duplicateParameter(parameter)"
                                        matTooltip="Duplică">
                                        <mat-icon>content_copy</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn" (click)="deleteParameter(parameter)"
                                        matTooltip="Șterge">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <!-- Expanded Details -->
                            <div class="parameter-details" *ngIf="parameter._expanded">
                                <div class="details-content">
                                    <div class="detail-section">
                                        <h4>Valoare implicită</h4>
                                        <p>{{ parameter.default_value || 'Nu este definită' }}</p>
                                    </div>
                                    <div class="detail-section" *ngIf="parameter.validation_rules">
                                        <h4>Reguli de validare</h4>
                                        <pre>{{ parameter.validation_rules }}</pre>
                                    </div>
                                    <div class="detail-section"
                                        *ngIf="parameter.type === 'select' && parameter.options">
                                        <h4>Opțiuni disponibile</h4>
                                        <div class="options-list">
                                            <span class="option-item"
                                                *ngFor="let option of getOptionsArray(parameter.options)">
                                                {{ option }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="detail-section">
                                        <h4>Utilizări în template-uri</h4>
                                        <div class="usage-templates"
                                            *ngIf="parameter.used_in_templates && parameter.used_in_templates.length > 0">
                                            <span class="template-chip"
                                                *ngFor="let template of parameter.used_in_templates">
                                                {{ template.name }}
                                            </span>
                                        </div>
                                        <p *ngIf="!parameter.used_in_templates?.length">Nu este utilizat în niciun
                                            template</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Empty State -->
                    <div class="empty-state" *ngIf="filteredParameters.length === 0">
                        <mat-icon>settings</mat-icon>
                        <p>Nu există parametri care să corespundă filtrelor selectate</p>
                        <button mat-stroked-button (click)="clearFilters()">
                            <mat-icon class="mb-0">close</mat-icon>
                            Șterge filtrele
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <!-- Parameter Editor Dialog -->
    <div class="editor-overlay" *ngIf="showEditor" (click)="closeEditor()">
        <div class="editor-dialog" (click)="$event.stopPropagation()">
            <div class="editor-header">
                <h3>{{ editingParameter?.id ? 'Editare parametru' : 'Parametru nou' }}</h3>
                <button mat-icon-button (click)="closeEditor()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div class="editor-content">
                <form class="parameter-form" *ngIf="editingParameter">
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="half-width">
                            <mat-label>Nume parametru</mat-label>
                            <input matInput [(ngModel)]="editingParameter.name" name="name" required>
                            <mat-error>Numele este obligatoriu</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="half-width">
                            <mat-label>Cheie parametru</mat-label>
                            <input matInput [(ngModel)]="editingParameter.parameter_key" name="key" required>
                            <mat-hint>Folosit în template-uri: {{editingParameter.parameter_key}}</mat-hint>
                        </mat-form-field>
                    </div>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Descriere</mat-label>
                        <textarea matInput [(ngModel)]="editingParameter.description" name="description"
                            rows="2"></textarea>
                    </mat-form-field>

                    <div class="form-row">
                        <mat-form-field appearance="outline" class="half-width">
                            <mat-label>Tip parametru</mat-label>
                            <mat-select [(ngModel)]="editingParameter.type" name="type" required>
                                <mat-option value="text">Text</mat-option>
                                <mat-option value="number">Număr</mat-option>
                                <mat-option value="date">Dată</mat-option>
                                <mat-option value="boolean">Da/Nu</mat-option>
                                <mat-option value="select">Listă opțiuni</mat-option>
                                <mat-option value="textarea">Text lung</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="half-width">
                            <mat-label>Categorie</mat-label>
                            <mat-select [(ngModel)]="editingParameter.category" name="category" required>
                                <mat-option value="system">Sistem</mat-option>
                                <mat-option value="user">Utilizator</mat-option>
                                <mat-option value="document">Document</mat-option>
                                <mat-option value="organization">Organizație</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Valoare implicită</mat-label>
                        <input matInput [(ngModel)]="editingParameter.default_value" name="defaultValue">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width" *ngIf="editingParameter.type === 'select'">
                        <mat-label>Opțiuni (separate prin virgulă)</mat-label>
                        <input matInput [(ngModel)]="editingParameter.options" name="options"
                            placeholder="Opțiunea 1, Opțiunea 2, Opțiunea 3">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Reguli de validare (JSON)</mat-label>
                        <textarea matInput [(ngModel)]="editingParameter.validation_rules" name="validation" rows="3"
                            placeholder='{"required": true, "minLength": 3}'></textarea>
                    </mat-form-field>

                    <div class="checkbox-group">
                        <mat-checkbox [(ngModel)]="editingParameter.is_required" name="required" color="primary">
                            Parametru obligatoriu
                        </mat-checkbox>
                        <mat-checkbox [(ngModel)]="editingParameter.is_active" name="active" color="primary">
                            Parametru activ
                        </mat-checkbox>
                        <mat-checkbox [(ngModel)]="editingParameter.is_global" name="global" color="primary">
                            Parametru global (disponibil pentru toate template-urile)
                        </mat-checkbox>
                    </div>
                </form>
            </div>

            <div class="editor-actions">
                <button mat-stroked-button (click)="closeEditor()">Anulează</button>
                <button mat-raised-button color="primary" (click)="saveParameter()"
                    [disabled]="!isParameterValid() || isSaving">
                    <mat-icon>save</mat-icon>
                    {{ isSaving ? 'Salvează...' : 'Salvează' }}
                </button>
            </div>
        </div>
    </div>

    <div class="browser-footer">
        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-secondary" (click)="onClose()">
                <i class="fas fa-times me-1"></i>
                Închide
            </button>
        </div>
    </div>
</div>